import { h } from 'preact';
import styles from "./style.scss";
import ReturnBack from "./ReturnBack";

const Success = () => {
  return (
    <main id="main-container" className={styles.wrapper} main-attr>
      <ReturnBack text="Руководство и педагогический состав" url="/rukovodstvo" />

      <h1>ЛНА ООО “ИТК”</h1>

      <ul className="pdfLinks">
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F11_Правила%20внутреннего%20трудового%20распорядка%20ИТК_подпись.pdf&name=11_Правила%20внутреннего%20трудового%20распорядка%20ИТК_подпись.pdf&nosw=1'} rel="noreferrer">
            Правила внутреннего трудового распорядка
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2F1W54f0CVod7gJNVvAF%2FPPo5p4GihjQ%2BF7E78wMVSrGyNym84EC421tkVQDTIlQqQq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2FПоложение%20о%20дистанционной%20работе.pdf&name=Положение%20о%20дистанционной%20работе.pdf&nosw=1'} rel="noreferrer">
            Положение о дистанционной работе работников
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F13_Положение%20о%20премировании%20ИТК.docx_подпись.pdf&name=13_Положение%20о%20премировании%20ИТК.docx_подпись.pdf&nosw=1'} rel="noreferrer">
            Положение о премировании работников
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F14_Положение%20о%20материальной%20ответственности.%20ИТК.docx_подпись.pdf&name=14_Положение%20о%20материальной%20ответственности.%20ИТК.docx_подпись.pdf&nosw=1'} rel="noreferrer">
           Положение о материальной ответственности
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F15_Положение%20о%20командировках%20ИТК.docx_подпись.pdf&name=15_Положение%20о%20командировках%20ИТК.docx_подпись.pdf&nosw=1'} rel="noreferrer">
            Положение о служебных командировках работников
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F16_Положение%20об%20аттестации%20работников%20ИТК_подпись.pdf&name=16_Положение%20об%20аттестации%20работников%20ИТК_подпись.pdf&nosw=1'} rel="noreferrer">
            Положение об аттестации работников ИТК
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F17_Положение%20о%20коммерческой%20тайне%20ИТК_подпись.pdf&name=17_Положение%20о%20коммерческой%20тайне%20ИТК_подпись.pdf&nosw=1'} rel="noreferrer">
            Положение о коммерческой тайне ИТК
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F18_Положение%20о%20КЭДО%20ИТК_подпись.pdf&name=18_Положение%20о%20КЭДО%20ИТК_подпись.pdf&nosw=1'} rel="noreferrer">
            Положение о КЭДО ИТК
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F19_Инструкция%20по%20охране%20труда%20дистанционных%20работников%20ИТК.docx_подпись.pdf&name=19_Инструкция%20по%20охране%20труда%20дистанционных%20работников%20ИТК.docx_подпись.pdf&nosw=1'} rel="noreferrer">
            Инструкция по охране труда дистанционных работников ИТК
          </a>
        </li>
        <li>
          <a target="_blank" href={'https://docs.yandex.by/docs/view?url=ya-disk-public%3A%2F%2Fq7PX9mO3QSyeWrhKVqFuDUBNBHjIoHnqNFbbG0Ilk0dkOP%2FIiKFS9izQ7S8a5zutq%2FJ6bpmRyOJonT3VoXnDag%3D%3D%3A%2F21_Положение%20KPI%20%20ИТК_подпись.pdf&name=21_Положение%20KPI%20%20ИТК_подпись.pdf&nosw=1'} rel="noreferrer">
            Положение KPI ИТК
          </a>
        </li>
      </ul>
    </main>
  );
};

export default Success;
